<template>
  <div class="card" v-loading="loading">
    <div class="card-body text-center">
      <img class="icon" src="@/assets/image/success.png" />
      <h5 class="text">{{$t('home.components.transaction.success')}}</h5>
      <h5 class="transaction" :class="income=='income'?'in':'out'">{{ income | formatIncome }}{{ amount }}MASS</h5>
    </div>
    <h5 class="title">{{$t('home.components.transaction.send')}}</h5>
    <div :class="(item.inputs || []).length<3?'inputs-mini':'inputs'">
      <div class="in-a-line" v-for="(trans,index) in item.inputs" :key="index">
        <h5 class="id">{{ trans.address }}</h5>
        <a class="explore" :href="$explorer+'address/' + trans.address">
          <img
            :title="$t('home.components.transaction.toExplorer')"
            width="10rem"
            src="@/assets/image/explore.png"
          />
        </a>
      </div>
    </div>
    <h5 class="title">{{$t('home.components.transaction.receive')}}</h5>
    <div :class="(item.outputs || []).length<3?'outputs-mini':'outputs'">
      <div class="in-a-line" v-for="(trans,index) in item.outputs" :key="index">
        <h5 class="id">{{ trans.address }}</h5>
        <a class="explore" :href="$explorer+'address/' + trans.address">
          <img
            :title="$t('home.components.transaction.toExplorer')"
            width="10rem"
            src="@/assets/image/explore.png"
          />
        </a>
      </div>
    </div>
    <h5 class="title">{{$t('home.components.transaction.fee')}}</h5>
    <h5 class="data">{{ parseFloat(fee.toFixed(8)) }}MASS</h5>
    <h5 class="title">{{$t('home.components.transaction.transID')}}</h5>
    <div class="in-a-line">
      <h5 class="id">{{ item.id }}</h5>
      <a class="explore" :href="$explorer+'tx/' + item.id">
        <img
          :title="$t('home.components.transaction.toExplorer')"
          width="10rem"
          src="@/assets/image/explore.png"
        />
      </a>
    </div>
    <h5 class="title">{{$t('home.components.transaction.height')}}</h5>
    <h5 class="data">{{ height }}</h5>
    <h5 class="title">{{$t('home.components.transaction.time')}}</h5>
    <h5 class="data">{{ time | formatTime }}</h5>
  </div>
</template>
<script>
import moment from "moment";
import { mapActions } from "vuex";

export default {
  props: {
    id: {
      type: String,
      default: "0",
    },
    amount: {
      type: String,
      default: "0",
    },
    income: {
      type: String,
      default: "0",
    },
  },
  methods: {
    ...mapActions("wallet", ["getTransactionItem"]),
  },
  computed: {
    height(){
      return this.item && this.item.block && this.item.block.height 
    },
    time(){
      return this.item && this.item.block && this.item.block.time
    }
  },
  data() {
    return {
      item: {},
      fee: 0,
      loading: true
    };
  },
  async mounted() {
    this.loading = true
    this.item = await this.getTransactionItem(this.id);
    console.log("1:", this.item);
    for (var i = 0; i < (this.item.inputs || []).length; i++) {
      this.fee += Number(this.item.inputs[i].amount);
    }
    for (var j = 0; j < (this.item.outputs || []).length; j++) {
      this.fee += Number(this.item.outputs[j].amount);
    }
    this.loading  = false
  },
  filters: {
    formatTime(val) {
      const zone = 8 * 60 * 60 * 1000
      return moment(new Date(val + zone)).format("YYYY-MM-DD HH:mm");
    },
    formatIncome(val){
      return (val=="income"?'+':'-');
    }
  },
};
</script>
<style lang="sass" scoped>
.card
  padding: 4rem 4.6rem
  min-width: 50rem
  .card-body
    .icon
      width: 4.6rem
    .text
      font-size: 1.4rem
      font-weight: bold
      color: #333333
      margin: 1.2rem 0 1.6rem 0
    .transaction
      font-size: 1.9rem
      font-weight: bold
      color: #D0021B
      margin-bottom: 4rem
    .out 
      color: #D0021B
    .in 
      color: #3C9B35
  .title
    font-size: 1.4rem
    font-weight: 400
    color: rgba(51,51,51,0.5)
    margin-bottom: 0.8rem
  .data
    font-size: 1.2rem
    font-weight: bold
    color: #333333
    margin-bottom: 1.5rem
  .in-a-line
    display: flex
    margin-bottom: 1.5rem
    .id
      font-size: 1.2rem
      font-weight: bold
      color: #333333
    .explore
      margin-left: 1rem
  .inputs-mini
    height: auto
  .inputs 
    margin-bottom: 1.5rem
    height: 5.2rem
    overflow: scroll
    .in-a-line
      display: flex
      margin-bottom: 1.5rem
      .id
        font-size: 1.2rem
        font-weight: bold
        color: #333333
      .explore
        margin-left: 1rem
  .outputs-mini
    height: auto
  .outputs
    margin-bottom: 1.5rem 
    height: 5.2rem
    overflow: scroll
    .in-a-line
      display: flex
      margin-bottom: 1.5rem
      .id
        font-size: 1.2rem
        font-weight: bold
        color: #333333
      .explore
        margin-left: 1rem
@media screen and (max-width: 768px)
  .card 
    min-width: auto
    .inputs
      width: 100%
      word-break: break-all
      height: 9.8rem
    .outputs
      width: 100%
      word-break: break-all
      height: 9.8rem
    .in-a-line
      width: 100%
      word-break: break-all 
</style>
